// CONSOLE-HOME و placeholder صفحات SCR-CONSOLE-* تا Prompt AP-PLT-02.
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { usePlatformSession } from '@phoenix/auth';
import { useTranslation } from '@phoenix/i18n';
import { EmptyState, ErrorState, ListPage, PageHeader } from '@phoenix/ui';
import { Link as RouterLink, useRouteError } from 'react-router';

export function ConsoleHomePage() {
  const { t, i18n } = useTranslation('console');
  const { me } = usePlatformSession();
  const roles = new Intl.ListFormat(i18n.language, { type: 'unit' }).format(me.platformRoles);
  return (
    <section data-screen-id="CONSOLE-HOME">
      <PageHeader titleKey="console:home.title" subtitleKey="console:home.description" />
      <Typography data-testid="platform-roles">{t('console:home.roles', { roles })}</Typography>
    </section>
  );
}

export function ConsoleComingSoonPage({ screenId, titleKey }: { screenId: string; titleKey: string }) {
  return (
    <ListPage screenId={screenId} titleKey={titleKey}>
      <EmptyState
        titleKey="shell:pages.coming_soon.title"
        descriptionKey="shell:pages.coming_soon.description"
      />
    </ListPage>
  );
}

export function ConsoleNotFoundPage() {
  const { t } = useTranslation('shell');
  return (
    <section data-screen-id="CONSOLE-NOT-FOUND">
      <EmptyState
        titleKey="shell:pages.not_found.title"
        descriptionKey="shell:pages.not_found.description"
        action={
          <Button component={RouterLink} to="/" variant="outlined">
            {t('shell:pages.back_home')}
          </Button>
        }
      />
    </section>
  );
}

export function ConsoleRouteErrorPage() {
  const error = useRouteError();
  return (
    <section data-screen-id="CONSOLE-ERROR">
      <ErrorState error={error} />
    </section>
  );
}
